import React, { useRef } from "react";
import {
  calcMargin,
  getAccuratePixels,
  getLogoPositionMatrix,
  LOGO_POSITION,
  MODULE,
} from "../../utils/global";
import Switch from "../Switch/Switch";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { useDraggable } from "../../context/DrabbleContext";
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import { BASE_URL } from "../../utils/code";
import WifyIcon from "../../assets/Icons/WifyIcon";

function SizeBox({
  size,
  color,
  frame,
  content,
  handleDrop,
  handleDragOver,
  handleDeleteElement,
  modifiedHandleDrop,
  modifiedHandleTouchEnd,
  handleTouchMove,
  selectedIcons,
  handleSetSelectIcon,
  deleteSelectedicon,
  downloadAs,
  isDownloadMode = false,
  logo,
  id = "",
  setContent,
}) {
  // We don't need to get touch handlers from context anymore as they are passed as props
  
  let mainBoardId = downloadAs ? `main-board-${id}` : "main-board";

  const moduleWidth = isDownloadMode
    ? MODULE[size].width + "px"
    : getAccuratePixels(MODULE[size].width);

  const moduleHeight = isDownloadMode
    ? MODULE[size].height + "px"
    : getAccuratePixels(MODULE[size].height);

  const modulePaddingTop = isDownloadMode
    ? MODULE[size].paddingTop + "px"
    : getAccuratePixels(MODULE[size].paddingTop);

  const modulePaddingBottom = isDownloadMode
    ? MODULE[size].paddingBottom + "px"
    : getAccuratePixels(MODULE[size].paddingBottom);

  const modulePaddingLeft = isDownloadMode
    ? MODULE[size].paddingLeft + "px"
    : getAccuratePixels(MODULE[size].paddingLeft);

  console.log(size);

  const modulePaddingRight = isDownloadMode
    ? MODULE[size].paddingRight + "px"
    : getAccuratePixels(MODULE[size].paddingRight);

  const isDownloadPng = downloadAs == "icon-png" || downloadAs == "cutout-png";

  const moduleWidthWrappper = isDownloadMode
    ? MODULE[size].width + 100
    : getAccuratePixels(MODULE[size].width + 100);

  const moduleHeightWrapper = isDownloadMode
    ? MODULE[size].height + 100
    : getAccuratePixels(MODULE[size].height + 100);

  const moduleWidthWrappperMain = isDownloadMode
    ? MODULE[size].width + 100 + 100
    : getAccuratePixels(MODULE[size].width + 100 + 100);

  const moduleHeightWrapperMain = isDownloadMode
    ? MODULE[size].height + 100 + 100
    : getAccuratePixels(MODULE[size].height + 100 + 100);

  const gap = isDownloadMode ? 154 : getAccuratePixels(154);

  const imageMatrix = getLogoPositionMatrix(size, frame);
  const logoImageTop = isDownloadMode
    ? imageMatrix?.bottom
    : getAccuratePixels(imageMatrix?.bottom);
  const logoImageRight = isDownloadMode
    ? imageMatrix?.right
    : getAccuratePixels(imageMatrix?.right);

  const logoImageTopLeft = isDownloadMode
    ? imageMatrix?.bottom
    : getAccuratePixels(imageMatrix?.bottom);
  const logoImageRightLeft = isDownloadMode
    ? imageMatrix?.right
    : getAccuratePixels(imageMatrix?.right);

  const logoImageWidth = isDownloadMode ? 188 : getAccuratePixels(188);
  const logoImageHeight = isDownloadMode ? 188 : getAccuratePixels(188);

  const radiusWidth = isDownloadMode ? 75 : getAccuratePixels(75);

  const isAllowBorderRadius = () => {
    if (frame == "module_touch_switch") {
      return false;
    }

    return true;
  };

  const isDisplayWidthAndPadding = () => {
    if (isDownloadPng && frame == "module_touch_switch") {
      return false;
    }

    return true;
  };

  console.log(logo, "logo");

  return (
    <>
      <div
        style={{
          width: isDisplayWidthAndPadding() ? moduleWidth : "fit-content",
          height: isDisplayWidthAndPadding() ? moduleHeight : "auto",
          backgroundColor: isDownloadPng ? "white" : color,
          display: "flex",
          flexDirection: "column",
          // alignItems: "center",
          borderRadius: isAllowBorderRadius() ? radiusWidth + "px" : "0",
          gap: gap,

          border: "1px solid lightgray",
          position: "relative",
          paddingTop: isDisplayWidthAndPadding() ? modulePaddingTop : "0",
          paddingBottom: isDisplayWidthAndPadding() ? modulePaddingBottom : "0",
          paddingLeft: isDisplayWidthAndPadding() ? modulePaddingLeft : "0",
          paddingRight: isDisplayWidthAndPadding() ? modulePaddingRight : "0",
        }}
        id={mainBoardId}
      >
        {content?.map((listItem) => {
          return (
            <div
              className="w-full"
              onDrop={(e) =>
                modifiedHandleDrop(e, undefined, listItem.key, isDownloadMode)
              }
              onDragOver={handleDragOver}
              // Add touch event handlers for the drop area
              onTouchEnd={(e) => 
                modifiedHandleTouchEnd(e, undefined, listItem.key, isDownloadMode)
              }
              onTouchMove={handleTouchMove}
              data-droppable="true"
              data-key={listItem.key}
              data-width={MODULE[size].width}
              data-height={MODULE[size].height}
              style={{
                // height: MODULE[size].width / content?.length,
                flex: 1,
              }}
              key={listItem?.id}
            >
              <div
                style={{
                  display: "flex",
                  // justifyContent: "center",
                  // alignItems: "center",
                  // gap: "20px",
                  // flexWrap: "wrap",
                }}
              >
                {listItem?.data?.map((item, index) => {
                  const marginRight = calcMargin(
                    listItem?.data,
                    item,
                    index,
                    size,
                    isDownloadMode
                  );

                  const width = isDownloadMode
                    ? item?.width + "px"
                    : getAccuratePixels(item?.width);

                  const height = isDownloadMode
                    ? item?.height + "px"
                    : getAccuratePixels(item?.height);

                  const WifiTopPosition = isDownloadMode
                    ? item?.wifiTop
                    : getAccuratePixels(item?.wifiTop);

                  const WifiBottomPosition = isDownloadMode
                    ? item?.wifiBottom
                    : getAccuratePixels(item?.wifiBottom);

                  const WifiLeftPosition = isDownloadMode
                    ? item?.wifiLeft
                    : getAccuratePixels(item?.wifiLeft);

                  const isDisplayWifiIcon =
                    item?.isDisplayWifi === false ? false : true;

                  return (
                    <div
                      key={item?.uid}
                      style={{
                        width: width,
                        height: height,
                        border:
                          isDownloadPng || downloadAs == "pdf"
                            ? ""
                            : "2px solid #6495ED",
                        display: "flex",
                        // flexDirection: "column",
                        flexWrap: "wrap",
                        // justifyContent: "center",
                        // alignItems: "center",
                        // gap: "15px",
                        position: "relative",
                        marginRight: marginRight + "px",
                        // flex: `0 0 ${width}`,
                        flexGrow: 0,
                        flexShrink: 0,
                        flexBasis: width,
                      }}
                      ondragover={handleDragOver}
                      onDrop={(e) =>
                        modifiedHandleDrop(
                          e,
                          index,
                          listItem.key,
                          isDownloadMode
                        )
                      }
                      // Add touch event handlers with data attributes
                      onTouchEnd={(e) => 
                        modifiedHandleTouchEnd(
                          e,
                          index,
                          listItem.key,
                          isDownloadMode
                        )
                      }
                      onTouchMove={handleTouchMove}
                      data-droppable="true"
                      data-index={index}
                      data-key={listItem.key}
                      data-width={width}
                      data-height={height}
                    >
                      <Switch
                        {...item}
                        isDownloadMode={isDownloadMode}
                        selectedIcons={selectedIcons}
                        handleSetSelectIcon={handleSetSelectIcon}
                        deleteSelectedicon={deleteSelectedicon}
                        downloadAs={downloadAs}
                        content={content}
                        itemKey={listItem.key}
                        setContent={setContent}
                        frame={frame}
                      />

                      {!downloadAs && (
                        <div
                          className="absolute -top-6 right-0 cursor-pointer "
                          onClick={() =>
                            handleDeleteElement(item?.uid, listItem?.key)
                          }
                        >
                          <DeleteIcon />
                        </div>
                      )}
                      {![
                        "rj45",
                        "rj11",
                        "usb",
                        "tv_socket",
                        "blank",
                        "indian_socket",
                        "Knob",
                        "universal_socket",
                        "international_socket",
                      ].includes(item?.type) &&
                        downloadAs != "cutout-png" &&
                        isDisplayWifiIcon && (
                          <div
                            style={{
                              position: "absolute",
                              bottom: WifiBottomPosition,
                              top: WifiTopPosition,
                              left: WifiLeftPosition,
                            }}
                          >
                            <WifyIcon
                              style={{
                                width: isDownloadMode ? 57 : 57 / 4,
                                height: isDownloadMode ? 57 : 57 / 4,
                                fill: "#6495ED",
                              }}
                              className={`${
                                isDownloadPng
                                  ? "switch-icon-color-black-main"
                                  : "switch-icon-color-main"
                              }`}
                            />
                          </div>
                        )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}

        <div
          style={{
            position: "absolute",
            bottom: logoImageTop,
            right: logoImageRight,
          }}
        >
          {logo?.image && logo?.image !== "null" && (
            <img
              src={logo?.image}
              width={logoImageWidth}
              height={logoImageHeight}
              crossOrigin="anonymous"
            />
          )}
        </div>

        {frame != "module_touch_switch" && (
          <>
            <div
              style={{
                position: "absolute",
                bottom: logoImageTopLeft,
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              {logo?.image3 && logo?.image3 !== "null" && (
                <img
                  src={logo?.image3}
                  width={logoImageWidth}
                  height={logoImageHeight}
                  crossOrigin="anonymous"
                />
              )}
            </div>

            <div
              style={{
                position: "absolute",
                bottom: logoImageTopLeft,
                left: logoImageRightLeft,
              }}
            >
              {logo?.image2 && logo?.image2 !== "null" && (
                <img
                  src={logo?.image2}
                  width={logoImageWidth}
                  height={logoImageHeight}
                  crossOrigin="anonymous"
                />
              )}
            </div>
          </>
        )}
      </div>

      {/* <button onClick={generatePDF}>Click</button> */}
    </>
  );
}

export default SizeBox;
